import React from 'react';
import { TMaterialTableColumns } from 'components/table/index.types';
import { TUserActivityLog } from 'types/entities/user-activity-logs';
import timeFormat from 'utils/time-format';
import { toSentenceCaseFormat } from 'utils/sentence-case-format';

const userActivityLogColumns = (): TMaterialTableColumns<TUserActivityLog> => [
    {
        width: '30',
        key: 'id',
        title: 'Log ID',
    },
    {
        width: '50',
        key: 'createdAt',
        title: 'Created At',
        render: (props) => {
            return <span>{timeFormat(props.rowData.createdAt)}</span>;
        },
    },
    {
        width: '50',
        key: 'userId',
        title: 'User ID',
    },
    {
        width: '50',
        key: 'nexId',
        title: 'User Nex ID',
    },
    {
        width: '70',
        key: 'actionType',
        title: 'Action Type',
        render: (props) => (
            <>{toSentenceCaseFormat(props.rowData.actionType)}</>
        ),
    },
    {
        width: '50',
        key: 'deviceId',
        title: 'Device ID',
    },
];

export default userActivityLogColumns;
